var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-input',_vm._g({class:[
    _vm.state ? 'border-danger bg-danger-outline' : ''
  ],attrs:{"id":_vm.id,"type":"number","autofocus":_vm.autofocus,"placeholder":_vm.placeholder,"max":_vm.maxValue,"min":_vm.minValue},on:{"input":_vm.onInput,"keydown":_vm.onKeyDown,"paste":_vm.onPaste,"blur":_vm.onBlur},model:{value:(_vm._dataModel),callback:function ($$v) {_vm._dataModel=_vm._n($$v)},expression:"_dataModel"}},_vm.$listeners))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-475f531e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom-components/InputNumberComponent.vue
// module id = null
// module chunks = 